import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { FormPostprocessorsComponent } from './form-postprocessors.component'
import { CreateFormPostprocessorComponent } from './create-form-postprocessor/create-form-postprocessor.component'
import { UpdateFormPostprocessorComponent } from './update-form-postprocessor/update-form-postprocessor.component'
import { formPostprocessorsRoutes } from './form-postprocessors.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { RadioModule } from '@components/radio/radio.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'
import { FormPostprocessorBuilderModule } from '@components/form-postprocessor-builder/form-postprocessor-builder.module'

@NgModule({
  declarations: [
    FormPostprocessorsComponent,
    CreateFormPostprocessorComponent,
    UpdateFormPostprocessorComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(formPostprocessorsRoutes, {
      scrollPositionRestoration: 'top',
    }),
    SharedModule,
    RadioModule,
    BreadcrumbsModule,
    FormPostprocessorBuilderModule,
  ],
  exports: [
    FormPostprocessorsComponent,
    CreateFormPostprocessorComponent,
    UpdateFormPostprocessorComponent,
  ],
})
export class FormPostprocessorsModule {}
